import { ParentWindowService } from "@parent-window/parent-window";
import { Store } from "@reduxjs/toolkit";
import { selectContactId } from "store/modules/session/session.selectors";
import { SetLocalStorageItemSafely } from "utils/set-local-storage-item";

export const ResetSessionAndReload = (store: Store) => {
  // console.log('Reset Session and Reload')
  const WIDGET_ID = (window as any).WIDGET_ID;
  const currentContactId = selectContactId(store.getState());
  ParentWindowService.sendMessage({
    type: "RESET_SESSION_AND_RELOAD",
    data: { currentContactId },
  });
  SetLocalStorageItemSafely(`CC_SESSION_TOKEN_${WIDGET_ID}`, "");
  // Get the current URL
  const currentUrl = new URL(window.location.href);

  // Remove the 'accessToken' query parameter
  currentUrl.searchParams.delete("accessToken");

  // Reload the page without the 'accessToken' parameter
  window.location.href = currentUrl.toString();
};
